import { render, staticRenderFns } from "./CostsTableEmpty.vue?vue&type=template&id=7c1d88ab&"
import script from "./CostsTableEmpty.vue?vue&type=script&lang=js&"
export * from "./CostsTableEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib'
installComponents(component, {VForm})
